import { render, staticRenderFns } from "./FmCascaderDemo.vue?vue&type=template&id=ebed5a64&scoped=true&"
import script from "./FmCascaderDemo.vue?vue&type=script&lang=js&"
export * from "./FmCascaderDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebed5a64",
  null
  
)

export default component.exports